<script>
import {ref} from "vue";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import Swals from "@/assets/js/Swals";
import FreeWorld from "@/assets/js/FreeWorld";

export default {
  name: "AddOffers",
  components: {LoadingPage},

  setup() {

    let loading = ref(false)

    let guilds = ref([])
    let category = ref([])
    let subcategory = ref([])
    let products = ref([])

    let states = ref([])
    let cities = ref([])

    let selects = ref({
      guilds: null,
      category: null,
      subcategory: null,
      product: null,
      brand: null,
      unit: null,
      prov_id: null,
      city_id: null,
      pnum: '',
      price: '',
    })

    function get_guilds() {
      loading.value = true
      FreeWorld.Heisenberg({action: 'all_guild'}, 'info').then((res) => {

        guilds.value = res.data
        selects.value.guilds = guilds.value[0].id
        chang_guilds('guilds')
        get_country()

      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, get_guilds, true)
      })
    }
    get_guilds()

    function get_country() {
      loading.value = true
      FreeWorld.Heisenberg({action: 'cities'}, 'info').then((res) => {

        loading.value = false
        states.value = res.data
        selects.value.prov_id = states.value[0].id
        cities.value = states.value[0].city
        selects.value.city_id = cities.value[0].id

      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, get_country, true)
      })
    }

    function chang_guilds(type) {

      switch (type) {

        case 'guilds':
          guilds.value.forEach((item_guild) => {
            if (item_guild.id === selects.value.guilds) {
              category.value = item_guild.category;
              if (category.value[0]) {
                selects.value.category = category.value[0].id
                subcategory.value = category.value[0].subcategory
                if (subcategory.value[0]) {
                  selects.value.subcategory = subcategory.value[0].id
                  products.value = subcategory.value[0].products

                  if (products.value[0]) {
                    selects.value.product = products.value[0].id
                    selects.value.brand = products.value[0].brand
                    selects.value.unit = products.value[0].unit
                  } else {
                    selects.value.product = null
                    selects.value.brand = null
                    selects.value.unit = null
                  }

                } else {
                  products.value = []
                  selects.value.category = null
                  selects.value.subcategory = null
                  selects.value.product = null;
                  selects.value.brand = null;
                  selects.value.unit = null;
                }

              } else {
                subcategory.value = []
                products.value = []
                selects.value.category = null
                selects.value.subcategory = null
                selects.value.product = null;
                selects.value.brand = null;
                selects.value.unit = null;
              }

              // category.value.forEach((item_category) => {
              //   if (item_category.id === selects.value.category) {
              //     subcategory.value = item_category.subcategory;
              //     if (subcategory.value[0]) {
              //       selects.value.subcategory = subcategory.value[0].id;
              //     } else {
              //       selects.value.subcategory = null
              //       selects.value.product = null;
              //       selects.value.brand = null;
              //       selects.value.unit = null;
              //     }
              //     subcategory.value.forEach((item_subcategory) => {
              //       if (item_subcategory.id === selects.value.subcategory) {
              //         products.value = item_subcategory.products;
              //         if (products.value[0]) {
              //           selects.value.product = products.value[0].id;
              //           selects.value.brand = products.value[0].brand;
              //           selects.value.unit = products.value[0].unit;
              //         } else {
              //           selects.value.product = null;
              //           selects.value.brand = null;
              //           selects.value.unit = null;
              //         }
              //       }
              //     });
              //   }
              // });
              return false
            }
          });
          break;

        case 'category':
          category.value.forEach((item_category) => {
            if (item_category.id === selects.value.category) {
              subcategory.value = item_category.subcategory;
              if (subcategory.value[0]) {
                selects.value.subcategory = subcategory.value[0].id
                products.value = subcategory.value[0].products

                if (products.value[0]) {
                  selects.value.product = products.value[0].id
                  selects.value.brand = products.value[0].brand
                  selects.value.unit = products.value[0].unit
                } else {
                  selects.value.product = null
                  selects.value.brand = null
                  selects.value.unit = null
                }

              } else {
                products.value = []
                selects.value.category = null
                selects.value.subcategory = null
                selects.value.product = null;
                selects.value.brand = null;
                selects.value.unit = null;
              }

              // subcategory.value.forEach((item_subcategory) => {
              //   if (item_subcategory.id === selects.value.subcategory) {
              //     products.value = item_subcategory.products;
              //     if (products.value[0]) {
              //       selects.value.product = products.value[0].id;
              //       selects.value.brand = products.value[0].brand;
              //       selects.value.unit = products.value[0].unit;
              //     } else {
              //       selects.value.product = null;
              //       selects.value.brand = null;
              //       selects.value.unit = null;
              //     }
              //   }
              // });
              return false
            }
          });
          break;

        case 'subcategory':
          subcategory.value.forEach((item_subcategory) => {
            if (item_subcategory.id === selects.value.subcategory) {
              products.value = item_subcategory.products;
              if (products.value[0]) {
                selects.value.product = products.value[0].id
                selects.value.brand = products.value[0].brand
                selects.value.unit = products.value[0].unit
              } else {
                selects.value.product = null
                selects.value.brand = null
                selects.value.unit = null
              }
              return false
            }
          });
          break;

        case 'product':
          products.value.forEach((item) => {
            if (item.id === selects.value.product) {
              selects.value.brand = item.brand;
              selects.value.unit = item.unit
            }
          })
          break;

      }

    }


    function change_state() {
      states.value.forEach((item) => {
        if (item.id === selects.value.prov_id) {
          cities.value = item.city
          selects.value.city_id = item.city[0].id
        }
      })
    }

    function Complete_offers() {

      if (selects.value.product === null) {
        Swals.Fault('لطفا محصول مورد نظر خود را انتخاب کنید!');
        return false
      }
      if (selects.value.pnum.length === 0) {
        Swals.Fault('لطفا حجم مورد نظر خود را انتخاب کنید!');
        return false
      }
      if (selects.value.price.length === 0) {
        Swals.Fault('لطفا مبلغ پیشنهادی خود را وارد کنید!');
        return false
      }

      let data = {
        pid: selects.value.product,
        pnum: selects.value.pnum,
        price: selects.value.price,
        prov_id: selects.value.prov_id,
        city_id: selects.value.city_id,
      }

      loading.value = true

      FreeWorld.Heisenberg(data, 'add_offer', true).then((res) => {

        loading.value = false
        if (res.data.status === 'ok') {
          Swals.Done('محصول پیشنهادی شما با موفقیت ثبت شد', 'OffersPage')
        } else {
          Swals.Fault('متاسفانه محصول پیشنهادی شما ثبت نشد!')
        }

      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, Complete_offers)
      })

    }


    return {

      loading,
      chang_guilds,
      selects,
      guilds,
      category,
      subcategory,
      products,
      change_state,
      states,
      cities,
      Complete_offers,

    }
  }
}
</script>


<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div id="main" :class="loading ? 'activeClass':'' " class="bg-main">

    <div class="div-top-arrow shadow-custom bg-white">
      <div class="d-flex justify-content-between align-items-center">
        <p class="font-color font-4 font-bold">فرم ثبت محصول</p>
        <img onclick="window.history.back()" class="svg-arrow" src="../assets/img/arrow.svg" alt="">
      </div>
    </div>
    <br>
    <br>
    <br>

    <div class="w-100 p-body bg-main mt-3 animate__animated animate__fadeIn">

      <div class="mt-5">
        <p class="mb-2 font-4 font-bold font-color">انتخاب صنف</p>
        <select @change="chang_guilds('guilds')" v-model="selects.guilds"
                class="text-center w-100 shadow-custom bg-white font-4 p-3 px-1 rounded-4">
          <option v-for="item in guilds" :key="item.id" :value="item.id">{{ item.name }}</option>
        </select>
      </div>

      <div class="mt-5">
        <p class="mb-2 font-4 font-bold font-color">انتخاب دسته بندی محصول</p>
        <select v-model="selects.category" @change="chang_guilds('category')"
                class="text-center w-100 shadow-custom bg-white font-4 p-3 px-1 rounded-4">
          <option v-for="item in category" :key="item.id" :value="item.id">{{ item.name }}</option>
        </select>
      </div>

      <div class="mt-5">
        <p class="mb-2 font-4 font-bold font-color">انتخاب دسته بندی سطح دوم </p>
        <select @change="chang_guilds('subcategory')" v-model="selects.subcategory"
                class="text-center w-100 shadow-custom bg-white font-4 p-3 px-1 rounded-4">
          <option v-for="item in subcategory" :key="item.id" :value="item.id">{{ item.name }}</option>
        </select>
      </div>

      <div class="mt-5">
        <p class="mb-2 font-4 font-bold font-color">انتخاب محصول</p>
        <select @change="chang_guilds('product')" v-model="selects.product"
                class="text-center font-4 w-100 shadow-custom bg-white p-3 px-1 rounded-4">
          <option v-for="item in products" :key="item.id" :value="item.id">{{ item.name }}</option>
        </select>
      </div>

      <div class="mt-5">
        <p class="mb-2 font-4 font-bold font-color"> برند محصول</p>
        <div v-if="selects.brand === null"
             class="shadow-custom text-disabled font-bold bg-white font-4 rounded-4 w-100 p-3 text-center">
          <p class="animate__animated animate__fadeIn">انتخاب نشده</p>
        </div>
        <div v-else class="shadow-custom text-disabled font-bold bg-white font-4 rounded-4 w-100 p-3 text-center">
          <p class="animate__animated animate__fadeIn">{{ selects.brand }}</p>
        </div>
      </div>

      <div class="mt-5">
        <p class="mb-2 font-4 font-bold font-color">واحد محصول</p>
        <div v-if="selects.unit === null"
             class="shadow-custom text-disabled font-bold bg-white font-4 rounded-4 w-100 p-3 text-center">
          <p class="animate__animated animate__fadeIn">انتخاب نشده</p>
        </div>
        <div v-else class="shadow-custom text-disabled font-bold bg-white font-4 rounded-4 w-100 p-3 text-center">
          <p class="animate__animated animate__fadeIn">{{ selects.unit }}</p>
        </div>
      </div>

      <div class="mt-5">
        <div class="mb-2 d-flex flex-column align-items-start">
          <p class="font-4 font-bold font-color" style="white-space: nowrap">حجم مورد نظر</p>
          <p class="font-5 font-color" style="white-space: nowrap">(انتخاب تعداد یا حجم بر اساس واحد محصول می باشد)</p>
        </div>
        <input v-model="selects.pnum" class="shadow-custom bg-white font-4 rounded-4 w-100 p-3 text-center"
               maxlength="4" onkeydown="return event.key !== ' '" type="number" placeholder="مثلا 5">
      </div>

      <div class="mt-5">
        <div class="me-2 mb-2 d-flex justify-content-between align-items-center">
          <p class="font-4 font-color">
            <span class="font-bold">قیمت کل</span>
            <span class="mr-1 font-5">(تومان)</span>
          </p>

          <p v-if="selects.price > 0"
             class="font-5 w-65 overflow-hidden font-color-green d-flex align-items-center justify-content-end">
            <span class="font-bold">{{ parseInt(selects.price).toLocaleString() }}</span>
            <span class="mr-1">تومان</span>
          </p>
        </div>
        <input v-model="selects.price" onkeydown="return event.key !== ' ' "
               class="shadow-custom bg-white font-4 rounded-4 w-100 p-3 text-center" type="number">
      </div>

      <div class="mt-5">
        <p class="mb-2 font-4 font-bold font-color">انتخاب استان مقصد</p>
        <select v-model="selects.prov_id" @change="change_state()"
                class="text-center w-100 shadow-custom bg-white p-3 rounded-4">
          <option v-for="item in states" :key="item.id" :value="item.id">{{ item.name }}</option>
        </select>
      </div>

      <div class="mt-5">
        <p class="mb-2 font-4 font-bold font-color">انتخاب شهر مقصد</p>
        <select v-model="selects.city_id" class="text-center w-100 shadow-custom  bg-white p-3 rounded-4">
          <option v-for="item in cities" :key="item.id" :value="item.id">{{ item.name }}</option>
        </select>
      </div>

      <div class="mt-10 mb-3">
        <v-btn @click="Complete_offers" class="h-100 w-100 p-3 rounded-3 bg-color font-bold text-white">ثبت نهایی
        </v-btn>
      </div>

    </div>
  </div>

</template>


<style scoped>


</style>